import { Injectable } from '@angular/core';
import { type Observable, shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';

import { type HttpDataResponse } from '@common/types/http-response.type';

import { BaseHttpService } from '@common/services/REST/base.http.service';

@Injectable({
    providedIn: 'root',
})
export class LogHttpService extends BaseHttpService {
    public sendLog(message: string): Observable<{ ok: boolean }> {
        return this.http.post<HttpDataResponse<{ ok: boolean }>>('/websites/builder/api/log', { message }).pipe(
            shareReplay(),
            map((res) => res.data)
        );
    }
}
